import React from "react";
import { useLang } from "../../lib/i18n";
import { trackBooking } from "../../lib/tracking";
import "./DoctolibWidget.css";

const PROFILE_URL =
  "https://www.doctolib.de/einzelpraxis/diez/preventum-diez";

const BOOKING_URL =
  `${PROFILE_URL}?utm_campaign=website-button&utm_source=online-booking&utm_medium=referral`;

const MESSAGE_URL =
  `${PROFILE_URL}/patient-request?utm_campaign=website-button&utm_source=patient-messaging&utm_medium=referral`;

export default function DoctolibWidget() {
  const { lang } = useLang();
  const isEnglish = lang === "en";

  return (
    <nav
      className="doctolib-widget"
      id="doctolib-nav"
      aria-label={isEnglish ? "Doctolib quick access" : "Doctolib Schnellzugriff"}
      data-testid="doctolib-widget"
    >
      <img
        src="/doctolib-white-transparent.png"
        alt="Doctolib"
        width="77"
        height="18"
      />
      <a
        href={BOOKING_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={isEnglish ? "Book an appointment online via Doctolib" : "Termin online über Doctolib buchen"}
        onClick={() => trackBooking("doctolib_widget")}
      >
        {isEnglish ? "Appointment" : "Termin"}
      </a>
      <a
        href={MESSAGE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={isEnglish ? "Send a message to the practice via Doctolib" : "Nachricht an die Praxis über Doctolib senden"}
      >
        {isEnglish ? "Message" : "Nachricht"}
      </a>
    </nav>
  );
}
